define('views/content/customer',['require','views/base/item_page_view','typeahead','bloodhound','jquery.scrollbar','moment','models/customer_manager','views/components/customer_settings/profile_settings','views/components/action_history/action_histories','collections/action_histories','views/components/customer_product/customer_products','collections/customer_products','views/components/recurring_customer_product_compact/recurring_products','collections/customer_recurring_products','views/components/customer_note/customer_notes','collections/customer_notes','models/customer_note','views/components/metrik_user/metrik_users','collections/metrik_users','views/modals/metrik_add','views/modals/assign','text!templates/content/customer.html'],function (require) {
  var BaseItemPageView = require("views/base/item_page_view");
  require("typeahead");
  require("bloodhound");
  require("jquery.scrollbar");

  var moment = require("moment");

  var CustomerManagerModel = require("models/customer_manager");
  var ManagerSettingsView = require("views/components/customer_settings/profile_settings");

  var ActionsView = require("views/components/action_history/action_histories");
  var ActionsCollection = require("collections/action_histories");

  var CompactCustomerProductsView = require("views/components/customer_product/customer_products");
  var CustomerProductsCollection = require("collections/customer_products");

  var CompactRecurringProductsView = require("views/components/recurring_customer_product_compact/recurring_products");
  var RecurringProductsCollection = require("collections/customer_recurring_products");

  var CustomerNotesView = require("views/components/customer_note/customer_notes");
  var CustomerNotesCollection = require("collections/customer_notes");
  var CustomerNoteModel = require("models/customer_note");

  var MetrikUsersView = require("views/components/metrik_user/metrik_users");
  var MetrikUsersCollection = require("collections/metrik_users");
  var MetrikUserAddModal = require("views/modals/metrik_add");
  var license_user_limits = {
    metriKpremium: 5,
    metriKstandard: 3,
    metriKbasic: 1,
  };

  var AssignModal = require("views/modals/assign");

  var temp = require("text!templates/content/customer.html");
  return BaseItemPageView.extend({
    // html template for the view
    template: _.template(temp),
    className: "customer-page page",
    basePath: "customers",
    titleKey: "customer",

    afterInitialize: function () {
      var _this = this;
      this.productsCollection = new CustomerProductsCollection([], {
        parameters: {
          customer_id: this.model.id,
        },
      });
      this.productsCollection.limit = 10;

      this.recurringProductsCollection = new RecurringProductsCollection([],{
        parameters:{
          customer_id: this.model.id
        },
      });

      this.recurringProductsCollection.limit = 10;

      this.notesCollection = new CustomerNotesCollection([], {
        parameters: {
          customer_id: this.model.id,
        },
      });

      this.actionsCollection = new ActionsCollection([], {
        parameters: {
          customer_id: this.model.id,
        },
      });

      this.metrikUserCollection = new MetrikUsersCollection([], {
        parameters: {
          customers__id: this.model.id,
        },
      });


      this.listenTo(this.metrikUserCollection, "fetch_complete", function () {
        _this.getMetrikLicenses(this.metrikUserCollection.length);
      });

      if (!this.model.get("id")) {
        // If creating a new object, add manager object to the model
        this.model.set("manager", new CustomerManagerModel().attributes);
        this.model.get("manager").password = "";
        this.model.get("manager").password_confirm = "";

        if (App.user.get("reseller")) {
          // If in reseller context, set reseller id for new customer
          this.model.set("reseller", App.user.get("reseller"));
        }
      } else if (this.model.get("id") && App.user.get("is_staff")) {
        this.manager = new CustomerManagerModel(
          this.model.get("manager_object")
        );
      }
    },

    ui: function () {
      return {
        select2Input: '[data-init-plugin="select2"]',
        mainForm: "#main-form",
        submitButton: "#submit-button-customer",

        managerForm: "#manager-form",

        resellerField: ".resellers-typeahead",
        chainField: ".chains-typeahead",
        cityField: ".cities-typeahead",

        licenseEmail: "#license_email",
        managerEmail: "#manager__email",
        countrySelect: "#country",
        stateSelect: "#state",

        phoneCountrySelect: "#phone_country",
        managerPhoneCountrySelect: "#manager__phone_country",

        newEmail: "#new_email",
        changeEmailButton: "#change-email-button",

        noteField: "#note",
        addNoteButton: "#add-note-button",

        clearKeyButton: "#clear-key-button",

        clearExtraButton: "#clear-extra-data-button",

        licenseList: ".license-list",

        addMetrikUserButton: "#add-metrik-user-button",

        userCount: ".users-count",

        assignButton : "#assign_to_customer_button"
      };
    },

    events: {
      "change form input": "formChanged",
      "change form textarea": "formChanged",
      "change form select": "formChanged",

      "change @ui.managerForm input": "formChanged",
      "change @ui.managerForm select": "formChanged",

      "change @ui.licenseEmail": "licenseEmailChanged",

      "click @ui.submitButton": "submitButtonClicked",

      "change @ui.countrySelect": "countryChanged",

      "click @ui.changeEmailButton": "changeEmailButtonClicked",

      "click @ui.addNoteButton": "addNoteButtonClicked",

      "click @ui.addMetrikUserButton": "addMetrikUserButtonClicked",

      "click @ui.clearKeyButton": "clearKeyButtonClicked",

      "click @ui.clearExtraButton": "clearExtraDataButtonClicked",
      
      "click @ui.assignButton": "assignButtonClicked",
    },

    regions: function () {
      return {
        LicensesContainer: ".license-list",
        RecurringProductContainer: ".subscription-product-list",
        NotesContainer: ".note-list",
        ActionsContainer: ".action-list",
        MetrikUserContainer: ".metrik-user-list",
        ManagerContainer: ".manager-setting",
      };
    },

    afterRender: function () {
      var _this = this;

      if (this.model.get("id")) {

        this.compactCustomerProductView = new CompactCustomerProductsView({
          collection: this.productsCollection,
        });

        this.compactRecurringProductsView =  new CompactRecurringProductsView({
          collection: this.recurringProductsCollection,
        });
    
        this.LicensesContainer.show(
          this.compactCustomerProductView
        );

        this.RecurringProductContainer.show(
          this.compactRecurringProductsView
        );

        this.NotesContainer.show(
          new CustomerNotesView({
            collection: this.notesCollection,
          })
        );

        this.ActionsContainer.show(
          new ActionsView({
            collection: this.actionsCollection,
          })
        );

        this.metrikUserView = new MetrikUsersView({
          collection: this.metrikUserCollection,
        });
        this.MetrikUserContainer.show(this.metrikUserView);

        if (App.user.get("is_staff")) {
          // Only staff can change customer manager
          this.ManagerContainer.show(
            new ManagerSettingsView({
              model: this.manager,
            })
          );
        }
      }

      if (
        App.user.get("is_staff") ||
        App.user.get("country_distributor") ||
        App.user.get("distributor")
      ) {
        // Setup typeahed for reseller field
        var resellersTypeahedEngine = new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.whitespace,
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          remote: {
            url: App.Config.apiBase + "resellers/typeahead/",
            replace: function (url, query) {
              return (
                url +
                ("?query=" + encodeURIComponent(_this.ui.resellerField.val()))
              );
            },
          },
          identify: function (obj) {
            return obj.id;
          },
        });

        this.ui.resellerField.typeahead(
          {
            minLength: 3,
          },
          {
            name: "resellers",
            source: resellersTypeahedEngine,
            display: "company_name",
          }
        );

        // Get selected reseller's id
        this.ui.resellerField.bind(
          "typeahead:select",
          function (ev, suggestion) {
            _this.model.set("reseller", suggestion.id);
          }
        );
      }

      // Setup typeahed for chain field
      var chainsTypeahedEngine = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
          url: App.Config.apiBase + "customer-chains/typeahead/",
          replace: function (url, query) {
            return url + ("?query=" + _this.ui.chainField.val());
          },
        },
        identify: function (obj) {
          return obj.id;
        },
      });

      this.ui.chainField.typeahead(
        {
          minLength: 3,
        },
        {
          name: "chains",
          source: chainsTypeahedEngine,
          display: "name",
        }
      );

      // Setup typeahed for city field
      var citiesTypeahedEngine = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
          url: App.Config.apiBase + "cities/typeahead/",
          replace: function (url, query) {
            var modifiedUrl = url + ("?query=" + _this.ui.cityField.val());

            if (_this.model.get("country")) {
              modifiedUrl += "&country=" + _this.model.get("country");
            }

            return modifiedUrl;
          },
        },
        identify: function (obj) {
          return obj.id;
        },
      });

      this.ui.cityField.typeahead(
        {
          minLength: 3,
        },
        {
          name: "cities",
          source: citiesTypeahedEngine,
          display: "name",
        }
      );
      // Get selected cities name
      this.ui.cityField.bind("typeahead:select", function (ev, suggestion) {
        _this.model.set("city_name", suggestion.name);
      });

      this.ui.licenseList.scrollbar();
    },

    setupFormValidation: function () {
      this.ui.mainForm.validate({
        rules: {
          reseller_object__company_name: "required",
          license_email: "required",
          company_name: "required",
          company_legal_name: "required",
          sector: "required",
          country: "required",
          city_name: "required",
          phone_country: "required",
          phone_value: "required",
          address: "required",

          manager__first_name: "required",
          manager__last_name: "required",
          manager__phone_country: "required",
          manager__phone_value: "required",
        },
        messages: {
          reseller_object__company_name: App.polyglot.t("reseller_required"),
          license_email: App.polyglot.t("email_required"),
          company_name: App.polyglot.t("company_name_required"),
          company_legal_name: App.polyglot.t("company_legal_name_required"),
          sector: App.polyglot.t("sector_required"),
          country: App.polyglot.t("country_required"),
          city_name: App.polyglot.t("city_required"),
          phone_country: App.polyglot.t("phone_country_required"),
          phone_value: App.polyglot.t("phone_value_required"),
          address: App.polyglot.t("address_required"),

          manager__first_name: App.polyglot.t("manager_first_name_required"),
          manager__last_name: App.polyglot.t("manager_last_name_required"),
          manager__phone_country: App.polyglot.t(
            "manager_phone_country_required"
          ),
          manager__phone_value: App.polyglot.t("manager_phone_value_required"),
        },

        onfocusout: false,
        onkeyup: false,
        onclick: false,

        showErrors: function (errorMap, errorList) {
          for (var i = 0; i < errorList.length; i++) {
            App.utils.showMessage("error", errorList[i].message);
          }
        },
      });
    },

    countryChanged: function () {
      var country_id = this.ui.countrySelect.val();

      if (country_id) {
        // Select same country in phone number field
        this.ui.phoneCountrySelect.val(country_id);
        this.ui.phoneCountrySelect.trigger("change");
        this.ui.managerPhoneCountrySelect.val(country_id);
        this.ui.managerPhoneCountrySelect.trigger("change");

        // Reset state and re render for state options of country
        this.ui.stateSelect.val(null);
        this.ui.stateSelect.trigger("change");
        this.render();
      }
    },

    licenseEmailChanged: function () {
      this.ui.managerEmail.val(this.ui.licenseEmail.val());
    },

    addNoteButtonClicked: function () {
      var _this = this;

      if (!this.ui.noteField.val()) {
        App.utils.showMessage("error", App.polyglot.t("no_note_entered"));
        return;
      }

      this.ui.addNoteButton.addClass("loading");

      var note = new CustomerNoteModel({
        customer: this.model.id,
        note: this.ui.noteField.val(),
      });

      note.save(null, {
        success: function (model, response, options) {
          _this.ui.addNoteButton.removeClass("loading");
          _this.render();
        },
        error: function (model, response, options) {
          _this.ui.addNoteButton.removeClass("loading");

          // Show error messages
          if (response.responseJSON.errors) {
            for (var i = 0; i < response.responseJSON.errors.length; i++) {
              App.utils.showMessage(
                "error",
                response.responseJSON.errors[i].message
              );
            }
          }
        },
      });
    },

    addMetrikUserButtonClicked: function () {
      var _this = this;
      if(!this.limit){
        App.utils.showMessage(
            "warning",
            App.polyglot.t("metrik_license_not_found")
          );
      }else if (this.count >= this.limit && this.limit != 5) {
        App.utils.showMessage(
          "warning",
          App.polyglot.t("metrik_user_limit_message")
        );
      } else {
        App.modalRegion.show(
          new MetrikUserAddModal({
            callback: function () {
              _this.metrikUserView.render();
            },
            customer: _this.model.id,
          })
        );
      }
    },

    changeEmailButtonClicked: function () {
      var _this = this;

      var newEmail = this.ui.newEmail.val();

      if (newEmail) {
        _this.ui.changeEmailButton.addClass("loading");

        $.ajax({
          url:
            App.Config.apiBase +
            "customers/" +
            this.model.get("id") +
            "/change_email/",
          method: "post",
          data: {
            email: newEmail,
          },
          success: function (response) {
            _this.ui.changeEmailButton.removeClass("loading");
            _this.model.set(response);
            _this.render();

            App.utils.showMessage(
              "success",
              App.polyglot.t("update_email_success")
            );
          },
          error: function (xhr, ajaxOptions, thrownError) {
            _this.ui.changeEmailButton.removeClass("loading");

            // Show error messages
            if (xhr.responseJSON.errors) {
              for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                App.utils.showMessage(
                  "error",
                  xhr.responseJSON.errors[i].message
                );
              }
            }
          },
        });
      }
    },

    clearKeyButtonClicked: function () {
      var _this = this;

      App.utils.showConfirmModal(
        App.polyglot.t("clear_key_confirm_message_reseller"),
        function () {
          $.ajax({
            url:
              App.Config.apiBase +
              "customers/" +
              _this.model.get("id") +
              "/clear_key/",
            method: "post",
            success: function (response) {
              App.utils.showMessage(
                "success",
                App.polyglot.t("clear_key_success_reseller")
              );
            },
            error: function (xhr, ajaxOptions, thrownError) {
              // Show error messages
              if (xhr.responseJSON.errors) {
                for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                  App.utils.showMessage(
                    "error",
                    xhr.responseJSON.errors[i].message
                  );
                }
              }
            },
          });
        }
      );
    },

    clearExtraDataButtonClicked: function () {
      var _this = this;

      App.utils.showConfirmModal(
        App.polyglot.t("clear_extra_data_confirm_message"),
        function () {
          $.ajax({
            url:
              App.Config.apiBase +
              "customers/" +
              _this.model.get("id") +
              "/clear_extra_data/",
            method: "post",
            success: function (response) {
              App.utils.showMessage(
                "success",
                App.polyglot.t("clear_extra_data_success")
              );
            },
            error: function (xhr, ajaxOptions, thrownError) {
              // Show error messages
              if (xhr.responseJSON.errors) {
                for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                  App.utils.showMessage(
                    "error",
                    xhr.responseJSON.errors[i].message
                  );
                }
              }
            },
          });
        }
      );
    },

    getMetrikLicenses: function (count) {
      var _this = this;
      this.count = count;

      $.ajax({
        url:
          App.Config.apiBase +
          "customer-licenses.json?name=metrik&customer_id=" +
          _this.model.id,

        type: "GET",

        data: {
          end_time_gte: moment().format("YYYY-MM-DD"),
        },

        success: function (data) {
          var results = data.results;

          if (results.length) {
            _this.limit = _this.findMetrikUserLimit(results);

            _this.updateUserCount(count, _this.limit);
          }
        },
      });
    },

    updateUserCount: function (count, limit) {
      var text = "";
      if (limit == 5) text = "( " + count + " )";
      else text = "( " + count + " / " + limit + " )";

      this.ui.userCount.text(text);
    },

    findMetrikUserLimit: function (licenses) {
      var limit = 0;

      for (var i = 0; i < licenses.length; i++) {
        
        if(license_user_limits[licenses[i].product.license_name] > limit)
            limit =license_user_limits[licenses[i].product.license_name];

      }

      return limit;
    },

    assignButtonClicked: function () {
      var _this = this;
      if (this.model.get("id")) {
        App.modalRegion.show(
          new AssignModal({
            selectedCustomer: this.model.get("id"),
            licensesRender: function () {
              _this.compactCustomerProductView.render();
            },
          })
        );
      }
    }
  });
});

